import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useNavigate } from "react-router-dom";

export default function NotificationBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const navigate = useNavigate();
  const load = () => api.get("/notifications").then(r => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  const onOpen = (o) => {
    if (o && data.unread) { api.post("/notifications/read-all").then(() => setData(d => ({ ...d, unread: 0 }))); }
  };
  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="relative w-8 h-8 rounded-md hover:bg-slate-100 flex items-center justify-center" aria-label="Notifications" data-testid="notif-bell">
          <Bell className="w-4 h-4 text-slate-600" />
          {data.unread > 0 && <span className="absolute -top-0.5 -right-0.5 bg-red-600 text-white text-[9px] font-bold rounded-full px-1" data-testid="notif-unread">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-0" data-testid="notif-panel">
        <div className="px-3 py-2 border-b text-xs font-semibold text-slate-600">Notifications</div>
        <div className="max-h-80 overflow-y-auto">
          {data.items.length === 0 && <div className="p-4 text-xs text-slate-500">Nothing yet.</div>}
          {data.items.map(n => (
            <button key={n.id} type="button" onClick={() => n.link && navigate(n.link)} className={`block w-full text-left px-3 py-2 border-b last:border-0 hover:bg-slate-50 ${n.read ? "" : "bg-blue-50/50"}`} data-testid={`notif-item-${n.id}`}>
              <div className="text-xs font-medium">{n.title}</div>
              <div className="text-[11px] text-slate-600">{n.body}</div>
              <div className="text-[10px] text-slate-400 mt-0.5">{(n.created_at || "").slice(0, 16).replace("T", " ")}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
